import type { PropsWithChildren } from 'react';
import { useParams } from 'next/navigation';
import {
  useGetAccountIdByProjectQuery,
  useGetAccountIdByWorkspaceQuery,
} from '@frameio/graphql-client/generated';
import { ensureString } from '@frameio/utils/formatters';
import { useActiveAccountId } from '../ActiveEntitiesContext';
import { IsolatedActiveAccountIdContextProvider } from '../ActiveEntitiesContext/ActiveAccountIdContext';

export const RouteDerivedAccountId = ({ children }: PropsWithChildren) => {
  const params = useParams();
  const activeAccountId = useActiveAccountId();
  const projectId = ensureString(params.projectId);
  const workspaceId = ensureString(params.workspaceId);

  // Get account ID from project ID in route path
  const { data: projectData } = useGetAccountIdByProjectQuery({
    variables: { projectId },
    skip: !projectId || Boolean(activeAccountId),
  });

  // Get account ID from workspace ID in route path
  const { data: workspaceData } = useGetAccountIdByWorkspaceQuery({
    variables: { workspaceId },
    skip: !workspaceId || Boolean(activeAccountId),
  });

  const accountId =
    activeAccountId ||
    projectData?.account?.project?.workspace?.accountId ||
    workspaceData?.account?.id ||
    undefined;

  return (
    <IsolatedActiveAccountIdContextProvider accountId={accountId}>
      {children}
    </IsolatedActiveAccountIdContextProvider>
  );
};
